import { render, staticRenderFns } from "./holandResult.vue?vue&type=template&id=a52a4f9e&scoped=true&"
import script from "./holandResult.vue?vue&type=script&lang=js&"
export * from "./holandResult.vue?vue&type=script&lang=js&"
import style0 from "./holandResult.vue?vue&type=style&index=0&id=a52a4f9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52a4f9e",
  null
  
)

export default component.exports